module.exports = __webpack_public_path__ + "media/images/media-08f5b9a419f8d7643648ae8389af2199.jpg";